const actions = {
  SET_STATE: 'project/SET_STATE',
  SET_SETTINGS: 'project/SET_SETTINGS',
  GET_SETTINGS: 'project/GET_SETTINGS',
}

export default actions
